import * as React from 'react';
import { Dispatch, DispatchWithoutAction } from 'react';
import cn from 'classnames';
import { GdsService_OrderAdditionalServiceGdsServiceVip_Fragment } from '@websky/graphql';
import { PassengersById, SegmentsById, State } from '../TransferService/model';
import { default as CheckoutAdditionalService } from '../../../CheckoutAdditionalService';
import { ServiceId } from '../../../types';
import TransferSelectorModal from '../TransferSelectorModal/TransferSelectorModal';
import { State as TransferSelectorState, useTransferSelector } from './model';
import TransferServiceSummary from '../TransferServiceSummary/TransferServiceSummary';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';

interface Props {
	service: GdsService_OrderAdditionalServiceGdsServiceVip_Fragment;
	servicesState: State['services'];
	passengers: PassengersById;
	segments: SegmentsById;
	isOpen: boolean;
	isSelected: boolean;
	onOpen: Dispatch<ServiceId>;
	onClose: DispatchWithoutAction;
	onChange: Dispatch<TransferSelectorState>;
}

const TransferSelector: React.FC<Props> = ({
	service,
	servicesState,
	isOpen,
	onClose,
	onOpen,
	segments,
	passengers,
	onChange,
	isSelected
}) => {
	const { t } = useTranslation('Transfer');
	const { TransferSelector: theme } = useTheme('Transfer');
	const model = useTransferSelector(service, servicesState, isOpen);

	return (
		<div>
			<CheckoutAdditionalService
				headerPriceClassName={theme.headerPrice}
				headerClassName={theme.header}
				headerTextClassName={theme.headerText}
				descriptionClassName={theme.description}
				dataRfisc={service.rfisc}
				buttonsClassName={theme.buttons}
				className={cn(theme.serviceCard, {
					[theme.active]: isSelected
				})}
				isSelected={isSelected}
				priceFrom={model.minPrice}
				hideFrom={true}
				priceTotal={model.totalPrice}
				header={service.name}
				description={service.description}
				addClick={() => onOpen(service.id)}
				buttons={[
					{
						text: t('Edit'),
						action: () => onOpen(service.id)
					}
				]}
			>
				<TransferServiceSummary
					service={service}
					segments={segments}
					servicesState={servicesState}
					passengers={passengers}
				/>
			</CheckoutAdditionalService>

			<TransferSelectorModal
				service={service}
				servicesState={model.state}
				onChange={model.toggleService}
				passengers={passengers}
				segments={segments}
				isOpen={isOpen}
				isDirty={model.isDirty}
				totalPrice={model.totalPrice}
				onSubmit={() => {
					onChange(model.state); // сохраняем родительский стейт (дергаем фактическое добавление )
					onClose();
				}}
				onClose={() => {
					model.restoreState(); // сбрасываем локальный стейт
					onClose();
				}}
				onClear={() => {
					model.removeTransfer(); // Сбросить текущий трансфер
				}}
			/>
		</div>
	);
};

export default TransferSelector;
